/**
 * SSR-safe `matchMedia` subscription.
 *
 * Always returns `false` on the server and for the first client render, so
 * markup gated on it never causes a hydration mismatch. Used to keep
 * desktop-only artwork out of the DOM on phones — `display:none` does not
 * stop an `<img>` from downloading, only not rendering it does.
 */
import { useEffect, useState } from "react";

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const sync = () => setMatches(mql.matches);
    sync();
    mql.addEventListener("change", sync);
    return () => mql.removeEventListener("change", sync);
  }, [query]);

  return matches;
}

/** Tailwind's `md` breakpoint, as a media query. */
export const MD_UP = "(min-width: 768px)";
